import React from "react";
import ManageSharePointReport from "../../components/ManageSharePointReports";
import { useParams } from "react-router";
import ManageInvoices from "../../components/ManageInvoices";
import ManageLinkIframe from "../../components/ManageLinkIframe";
import { ManageSchedular } from "../../components/ManageSchedular";
import Documents from "../../components/Content/Documents";
import { useSelector } from "react-redux";

const Widget = () => {
  const { currentUser: user } = useSelector((store) => store.userReducer);
  const { type } = useParams();
  if (type.toLowerCase() == "idrb") {
    return <ManageInvoices></ManageInvoices>;
  } else if (type.toLowerCase() == "link") {
    return <ManageLinkIframe></ManageLinkIframe>;
  } else if (type.toLowerCase() == "m365") {
    return <ManageSharePointReport></ManageSharePointReport>;
  } else if (type.toLowerCase() == "opsgenie") {
    return <ManageSchedular></ManageSchedular>;
  }
  // else if (type.toLowerCase() == "fileexplorer") {
  //   return <Documents permissions={{ get: { DOWNLOAD: user.isAdmin }, post: { DELETE: user.isAdmin, CREATE: user.isAdmin, UPLOAD: user.isAdmin } }}></Documents>;
  // }
};

export default Widget;
